// @flow

import axios from 'axios';
import config from '../config';

export const setHTTPToken = (token: string) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const clearHTTPToken = () => {
  axios.defaults.headers.common['Authorization'] = null;
};

export const setupAxios = (userToken: string | null): void => {
  axios.defaults.baseURL = config.api_url;
  axios.defaults.withCredentials = true;
  axios.defaults.validateStatus = status => status >= 200 && status < 300;

  axios.interceptors.response.use(
    response => response,
    error => {
      if (
        error.response &&
        error.response.status === 401 &&
        !error.response.config.url.includes(config.login_api_url) &&
        location.pathname !== '/'
      ) {
        location.href = '/';
      }

      return Promise.reject(error);
    }
  );

  if (userToken) {
    setHTTPToken(userToken);
  }
};
